import { combineReducers } from 'redux'
import engagement from './engagement'

const overtimeGraphs = combineReducers({
  engagement,
})

export default overtimeGraphs
